<template>
    <div class="mt-2">
        <UserOrganizationsCard
            :account="account"
            @org-role-changed="refreshAvailableOrganizations"
            @orgs-saved="refreshAvailableOrganizations"
        />
    </div>
</template>

<script>
import UserOrganizationsCard from '@/components/UserOrganizationsCard'
import {switchSelectedOrganization} from '@/services/userService'

export default {
    name: "AccountUserOrganizations",
    components: { UserOrganizationsCard },
    props: {
        account: {
            required: true
        }
    },
    methods: {
        async refreshAvailableOrganizations() {
            // Re-hydrate the current account's availableOrganizations (powers the
            // top-right org switcher). Calling switchSelectedOrganization with the
            // already-selected org id reuses the existing login response shape and
            // updates Vuex.
            const currentOrgId = this.$store.getters.selectedOrganizationId
            if (currentOrgId) {
                await switchSelectedOrganization(currentOrgId)
            }
        }
    }
}
</script>
